import { Alert } from "@circleco/compass/components/Alert";

import { t } from "@/i18n-js/instance";
import { useCommentsConfig } from "@/react/components/CommentsCompass/Provider/ConfigContext";

interface ClosedBannerProps {
  description?: string;
}

export const ClosedBanner = ({
  description = t("post.comments_section.comments_closed"),
}: ClosedBannerProps) => {
  const { isCommentsClosed } = useCommentsConfig();

  if (!isCommentsClosed) return null;

  return <Alert icon="lock" description={description} />;
};
